import React, { useState } from "react";
import stars from "@/assets/icons/stars.svg";
import { Pagination, Skeleton } from "@mui/material";
import { useGetUsersQuery } from "@/store/rtk-api/users.api";
import { IAdminFireBase } from "@/store/models/admin.models";
import { withAdmin } from "@/services/withAdmin";
import searchIcon from "@/assets/icons/search.svg";
import { IUser, UserRole } from "@/store/models/users.models";
import styles from "./UsersPage.module.scss";
import { InputText } from "@/components/InputText/InputText";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Layout from "@/components/Layout/Layout";
import useItemsPerPage from "@/hooks/useItemsPerPage";

const UsersPageCmp: React.FC<{ admin: IAdminFireBase }> = ({ admin }) => {
  const [page, setPage] = useState(1);
  const { control, watch } = useForm();
  const itemsPerPage = useItemsPerPage(4, 8, 12, 1010, 1440);
  const navigate = useNavigate();
  const searchInput = watch("search");
  const {
    data: usersData,
    isLoading,
    isSuccess,
  } = useGetUsersQuery({
    page,
    limit: itemsPerPage,
    email: searchInput,
  });

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPage(1);
  };

  const navigateToUser = (user: IUser) => {
    navigate(`/users/${user.email}`, { state: { user } });
  };

  return (
    <Layout admin={admin}>
      <InputText
        label="Search"
        control={control}
        name="search"
        icon={searchIcon}
        onChange={handleSearchChange}
      />
      <div className={styles.contentWithPagination}>
        <div className={styles.usersCards}>
          {isLoading &&
            [...Array(10)].map((_, index) => (
              <div className={styles.userCard} key={index}>
                <Skeleton variant="rounded" width={40} height={40} />
                <Skeleton variant="rounded" width={200} height={20} />
                <Skeleton variant="rounded" width={20} height={20} />
              </div>
            ))}
          {isSuccess &&
            usersData.data.map((user) => (
              <div
                className={styles.userCard}
                key={user.internal_id}
                onClick={() => navigateToUser(user)}
              >
                <div
                  className={`${styles.userLabel} ${
                    user.role === UserRole.free
                      ? styles.userLabelFree
                      : user.role === UserRole.premium
                        ? styles.userLabelPremium
                        : user.role === UserRole.banned
                          ? styles.userLabelBanned
                          : ""
                  }`}
                >
                  {user.role}
                  {user.role === UserRole.premium && (
                    <img src={stars} alt="stars" />
                  )}
                </div>
                <div className={styles.userInfoWrap}>
                  <div className={styles.userInfo}>
                    <p className={styles.userEmail}>{user.email}</p>
                  </div>
                </div>
              </div>
            ))}
        </div>
        {isSuccess && (
          <Pagination
            page={page}
            onChange={handlePageChange}
            count={Math.ceil(usersData.total / itemsPerPage)}
          />
        )}
      </div>
    </Layout>
  );
};

export const UsersPage = withAdmin(UsersPageCmp);
UsersPageCmp.displayName = "UsersPageCmp";

